const COMPANY_URL_SUBSTRINGS = [
  "companies",
  "factoring",
  "leasing",
  "cash-management",
  "income-trading",
  "investment-fund",
  "partnership",
  "buisness-investment",
];

/* Pages reachable from both the individuals and the companies experience:
 * they keep whichever side the visitor arrived from. */
const SHARED_URL_SUBSTRINGS = [
  "about",
  "contact-us",
  "media",
  "blogs",
  "careers",
  "our-brands",
  "insurance",
  "sarwa-life",
  "sarwa-insurance",
];

const COMPANY_FLAG_KEY = "flag";

/*
 * Reads the persisted flag without `eval`. Only "true"/"false" are ever
 * written, and a missing key keeps returning null exactly as `eval(null)` did.
 */
const readCompanyFlag = () => {
  const stored = localStorage.getItem(COMPANY_FLAG_KEY);

  if (stored === null) return null;

  return stored === "true";
};

/*
 * Which side of the site a path belongs to, judged from the path alone:
 * true for companies, false for individuals, null when the page is reachable
 * from both and only the visitor's history can decide.
 *
 * Usable on the server, unlike `isCompany` below.
 */
export const audienceFromPath = (pathname = "") => {
  if (COMPANY_URL_SUBSTRINGS.some((substring) => pathname.includes(substring))) {
    return true;
  }

  if (SHARED_URL_SUBSTRINGS.some((substring) => pathname.includes(substring))) {
    return null;
  }

  return false;
};

export const isCompany = () => {
  if (typeof window === "undefined") return undefined;

  const fromPath = audienceFromPath(window.location.pathname);

  /* Shared pages keep whichever side the visitor arrived from. */
  if (fromPath === null) return readCompanyFlag();

  localStorage.setItem(COMPANY_FLAG_KEY, fromPath);
  return fromPath;
};
export const truncateString = (str, maxLength, suffix = "...") => {
  if (str.length <= maxLength) {
    return str;
  }
  return str.substring(0, maxLength - suffix.length) + suffix;
};

export const userAgent = (isoUrl, androidUrl, webUrl) => {
  if (typeof window !== "undefined") {
    function isIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    function isAndroid() {
      return /Android/i.test(navigator.userAgent);
    }

    if (isIOS()) {
      // return "iso";
      return isoUrl;
    } else if (isAndroid()) {
      // return "android";
      return androidUrl;
    } else {
      // return "web";
      return androidUrl;
    }
  }
};

export const renderString = (string, locale) => {
  const findSubstringIndex = (string, substring) => {
    return string.toLowerCase().indexOf(substring.toLowerCase());
  };
  const substring = locale === "en" ? "Kol Yom" : "كل يوم";
  const index = findSubstringIndex(string, substring);
  if (index !== -1) {
    return (
      <div>
        {string.substring(0, index)}
        <span style={{ color: "rgb(241, 130, 34)" }}>
          {string.substring(index, index + substring.length)}
        </span>
        {string.substring(index + substring.length)}
      </div>
    );
  } else {
    return <div>{string}</div>;
  }
};

export const isImgUrl = (url) => {
  const img = new Image();
  img.src = url;
  return new Promise((resolve) => {
    img.onerror = () => resolve(false);
    img.onload = () => resolve(true);
  });
};
